/**
 * Function that sets up all the event listeners
 */
const setupListeners = () => {
    $("#scroll-top").click((_) => {
        $("html, body").animate({ scrollTop: 0 }, 500);
    });

    $(".footer-submenu-toggle").click(function () {
        console.log("clicked", this);
        const dropdown = $(this).parent().siblings(".block-content");

        if ($(dropdown).hasClass("active")) {
            $(dropdown).slideUp();
            $(dropdown).removeClass("active");
            $(this).find("i").attr("class", "fa-sharp fa-solid fa-plus");
        } else {
            $(dropdown).slideDown();
            $(dropdown).addClass("active");
            $(this).find("i").attr("class", "fa-sharp fa-solid fa-minus");
        }
    });
};

// Document ready, runs when the page is loaded
document.addEventListener("DOMContentLoaded", function () {
    setupListeners();
});
